module.exports = __webpack_public_path__ + "static/media/business-img3.0357c5d9.svg";